(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();

      // Sticky behaviour is DESKTOP-ONLY. Below 990px the header must stay
      // in normal flow, so we never add/keep any of the sticky classes on
      // mobile/tablet, and no scroll handling runs there either.
      this.desktopQuery = window.matchMedia('(min-width: 990px)');
      this.mediaQuery = window.matchMedia('(max-width: 990px)');
      this.onMediaChange = this.setHeaderHeight.bind(this);
      this.mediaQuery.addEventListener('change', this.onMediaChange);
      this.onDesktopQueryChange = this.handleViewportChange.bind(this);
      this.desktopQuery.addEventListener('change', this.onDesktopQueryChange);

      if (this.headerIsAlwaysSticky && this.desktopQuery.matches) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();

      // Make sure nothing sticky lingers if the page loads directly on mobile.
      if (!this.desktopQuery.matches) this.clearStickyClasses();
    }

    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.mediaQuery?.removeEventListener('change', this.onMediaChange);
      this.desktopQuery?.removeEventListener('change', this.onDesktopQueryChange);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, currentObserver) => {
        this.headerBounds = entries[0].intersectionRect;
        currentObserver.disconnect();
      });
      observer.observe(this.header);
    }

    // Strip every sticky/scrolled class so mobile always renders in normal flow.
    clearStickyClasses() {
      this.header.classList.remove(
        'scrolled-past-header',
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
      this.preventReveal = false;
      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    }

    // When crossing the 990px breakpoint, reset state so behaviour switches
    // cleanly between "sticky on desktop" and "normal flow on mobile".
    handleViewportChange(event) {
      if (event.matches) {
        // Entered desktop: re-apply always-sticky if that's the chosen type.
        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      } else {
        // Entered mobile/tablet: sticky is fully disabled.
        this.clearStickyClasses();
      }
    }

    onScroll() {
      // Sticky/hide-reveal logic only ever runs on desktop widths.
      if (!this.desktopQuery.matches) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
